/* MIXINS */
import permissionsMixin from '@mixins/permissionsMixin';

export default {
  mixins: [permissionsMixin],
  data() {
    return {
      activeTab: undefined,
      tabs: [
        {
          name: this.$t('accommodation.list'),
          id: 'housekeeperAccommodations',
          active: true,
        },
        {
          name: this.$t('housekeeper.accommodations_history'),
          id: 'housekeeperAccommodationsHistory',
          active: true,
        },
      ],
    };
  },
  computed: {
    getTabs() {
      return this.tabs;
    },
    getActiveTab() {
      return this.activeTab;
    },
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab.id;
      if (this.$refs.tabView) this.$refs.tabView.scrollToTop();
    },
  },
};
